module.exports = __webpack_public_path__ + "static/img/pic_productcase@2x.8cb75f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduceAndCase/pic_productcase@2x.png
// module id = MM3s
// module chunks = 0